export enum OrderStatusEnum {
  ALL="ALL",
  CURRENT_ORDER = "Current order",
  To_Pack = "To pack",
  To_Ship = "To ship",
  Rider_Getting_Order = "Rider getting order",
  Shipping = "Shipping",
  Delivered = "Delivered",
  Return = "Return",
  Failed = "Failed",
  READY_TO_PICKUP = "Ready to pick up",
  PARTIALLY="Partially"
}
